// The everyday functional record control: small, conventional, on-brand
// (ink border, hard shadow, red dot/stop glyph) — deliberately plainer than
// the decorative Orbit hero graphic. Lives inside the live preview box.

export type RecordState = 'idle' | 'armed' | 'recording' | 'paused' | 'error';

export interface RecordCopy {
  ariaLabel: string;
  title: string;
  detail: string;
}

export class RecordControl {
  private root: HTMLElement;
  private button: HTMLButtonElement;
  private timerEl: HTMLElement;
  private titleEl: HTMLElement;
  private detailEl: HTMLElement;
  private state: RecordState = 'idle';

  constructor(root: HTMLElement) {
    this.root = root;
    this.button = root.querySelector('.record-btn-small') as HTMLButtonElement;
    this.timerEl = root.querySelector('#button-timer') as HTMLElement;
    this.titleEl = document.getElementById('status-title') as HTMLElement;
    this.detailEl = document.getElementById('status-detail') as HTMLElement;
  }

  onClick(handler: () => void): void {
    this.button.addEventListener('click', handler);
  }

  get currentState(): RecordState {
    return this.state;
  }

  setState(state: RecordState, copy: RecordCopy): void {
    this.state = state;
    this.root.dataset.state = state;
    this.button.setAttribute('aria-label', copy.ariaLabel);
    this.button.setAttribute('aria-pressed', state === 'recording' || state === 'paused' ? 'true' : 'false');
    this.titleEl.textContent = copy.title;
    this.detailEl.textContent = copy.detail;
  }

  setTimerText(text: string): void {
    this.timerEl.textContent = text;
  }

  setDisabled(disabled: boolean): void {
    this.button.disabled = disabled;
  }
}

/** 3-2-1 countdown. Resolves early (false) if `cancelled()` starts returning true. */
export async function countdown(control: RecordControl, seconds: number, cancelled: () => boolean): Promise<boolean> {
  for (let n = seconds; n >= 1; n--) {
    if (cancelled()) return false;
    control.setTimerText(String(n));
    await new Promise((r) => setTimeout(r, 800));
  }
  return !cancelled();
}
